import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Loader2, Ticket } from "lucide-react";
import customerApi from "./customerApi";
import { TicketStub } from "../pages/OpenDayTicketPage";

const LABEL = { paid: "Confirmed", comp: "Complimentary", pending: "Awaiting payment", cancelled: "Cancelled", refunded: "Refunded" };

export default function HQTickets() {
  const [rows, setRows] = useState(null);
  useEffect(() => { customerApi.get("/customer/open-day-tickets").then((r) => setRows(r.data || [])).catch(() => setRows([])); }, []);
  const live = (rows || []).filter((r) => r.status === "paid" || r.status === "comp");
  const other = (rows || []).filter((r) => r.status !== "paid" && r.status !== "comp");

  return (
    <div className="space-y-6" data-testid="hq-tickets">
      <div>
        <div className="text-[10px] tracking-[0.4em] uppercase font-semibold text-[#6E1E3A]">Heritage Open Days</div>
        <h1 className="font-serif text-3xl text-[#3C2A1E] mt-1">My Tickets</h1>
        <p className="text-sm text-[#7A6A55] mt-1">Your Open Day tickets, ready to show at the gate.</p>
      </div>
      {rows === null ? <Loader2 className="w-5 h-5 animate-spin text-[#6E1E3A]" /> : rows.length === 0 ? (
        <div className="bg-white border border-[#E8DFCB] rounded-2xl p-8 text-center" data-testid="hq-tickets-empty">
          <Ticket className="w-8 h-8 mx-auto text-[#6E1E3A]" />
          <p className="mt-3 text-[#3C2A1E]">No tickets yet. Three parties, one summer , come and see us.</p>
          <Link to="/dahlias/private-pickings#open-days" className="inline-block mt-4 px-5 h-10 leading-10 rounded-full bg-[#6E1E3A] text-white text-[11px] tracking-[0.2em] uppercase font-bold" data-testid="hq-tickets-browse">See the Open Days</Link>
        </div>
      ) : (
        <>
          {live.map((o) => <TicketStub key={o.id} o={o} />)}
          {other.length > 0 && (
            <div className="space-y-2">
              <h2 className="text-base md:text-lg font-serif text-[#3C2A1E]">Other ticket orders</h2>
              {other.map((o) => (
                <div key={o.id} className="bg-white border border-[#E8DFCB] rounded-xl px-4 py-3 flex flex-wrap items-center justify-between gap-2 text-sm" data-testid={`hq-ticket-row-${o.ref}`}>
                  <div><span className="font-semibold text-[#3E1F46]">{o.event_title}</span> · {o.ref} · {o.qty_total} ticket{o.qty_total === 1 ? "" : "s"}</div>
                  <div className="flex items-center gap-3">
                    <span className={`text-[10px] uppercase tracking-[0.2em] font-bold ${o.status === "pending" ? "text-[#8B4A0B]" : "text-[#A33030]"}`}>{LABEL[o.status] || o.status}</span>
                    {o.status === "pending" && <Link to={`/visit/tickets/${o.id}`} className="px-3 h-8 leading-8 rounded-full bg-[#6E1E3A] text-white text-[10px] tracking-[0.2em] uppercase font-bold" data-testid={`hq-ticket-pay-${o.ref}`}>Finish paying</Link>}
                  </div>
                </div>
              ))}
            </div>
          )}
        </>
      )}
    </div>
  );
}
